import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { resetState, goToPage, validateMailHandler , changeMailHandler, stepParams, setTimeDisconnectOccurred, disconnectProduct, setDisconnectTypeOfService, setServiceToDisconnect } from '../../DisconnectServiceSlice'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import images from '../../DisconnectPhotos/images'
import TextInput from '../../../../Shared/TextInput/TextInput';
import { PopUpContent } from '../DisconnectCommonParts/PopUpAction'
import PopUp from '../../../../Shared/Popup/PopUp'
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import { Container, Row, Col } from 'reactstrap';
import Config from '../../../../../Config'
import getDates from './datesToDisconnect'
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import Helper from '../../../../../utilities/analytics/helper'
import { isBrowser } from "react-device-detect";
import useExtendedEffect from '../../../../../utilities/hooks/useExtendedEffect';
import { clearStateHistoryAction } from '../../../../../utilities/stateHistory/stateHistorySlice';

function SummarizeSelfDisconnect(props) {
    
    const valid = props.mailForm.emailForm.valid;
    const [isShow, setIsShow] = useState(false);
    const [isShowOther, setIsShowOther] = useState(false)
    const [clicked, setClicked] = useState(false);
    const [active, setActive] = useState(true);

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_SUMMARIZE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_ENTER_SUMMARIZE_DISCONNECT_PAGE.eventType, props.serviceToDisconnect.serviceType);
      }, [])

    useEffect(() => {
        if(props.mailForm.emailForm.email != '') {
            props.validateMailHandler(props.mailForm.emailForm);
            if(valid) {
                setActive(true);
            }
            if(props.emailInStore.email && props.emailInStore.email != "" && props.emailInStore.errors.email != "") {
                setActive(false);
            }
        }
    }, [valid, clicked, props.emailInStore.errors.email])

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if(props.finalDisconnectResponse === false) {
                props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: true } })
            }
            if(props.finalDisconnectResponse === true) {
                gaEvent(gaParams.DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.category, gaParams.DISCONNECT_ENTER_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.eventType, props.serviceToDisconnect.serviceType)
            }
        }
    },[props.finalDisconnectResponse])

    const days = ['יום א', 'יום ב', 'יום ג', 'יום ד', 'יום ה', 'יום ו', 'יום ש'];
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;

    const todayFull = new Date();
    const todayStr = `${String(todayFull.getDate()).padStart(2, '0')}/${String(todayFull.getMonth() + 1).padStart(2, '0')}/${todayFull.getFullYear()}`;
    const dayName = days[todayFull.getDay()];
    const displayFullDay = todayStr + ' ' + dayName;

    function closeItemsPopUp() {
        setIsShowOther(!isShowOther)
    }

    function closePopUp() {
        gaEvent(gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_ME_IN_POP_UP.category, gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_ME_IN_POP_UP.eventType, props.serviceToDisconnect.serviceType)
        setIsShow(false);
    }

    function getKits(kit) {
        let kitProducts = [];
        if(kit.kitProducts && kit.kitProducts.length > 0) {
            kitProducts = kit.kitProducts.map(function(kitProduct, index){
                let equipment = (props.equipmentList || []).find(function(equ){
                    return equ.id.value === kitProduct.productId
                })
                if(equipment) {
                    // Take image
                    return (
                    <div key={index} className="equipmentBox">
                        <div className="equipmentDetails">
                            <div>{equipment.description.value}</div>
                            <Image className="img" alt="equipment" src={Config.epiBaseUrl + equipment.photoSmall.value.url} />
                        </div>
                    </div> )  
                }
                else {
                    // default img
                    return (
                        <div key={index} className="equipmentBox">
                            <div className="equipmentDetails">
                                <div>{kitProduct.title}</div>
                                <Image alt="not found" src={images.default} className="img" /> 
                            </div>
                        </div> )  
                }
            })
        }
        return kitProducts
    }

    const kits = props.equipmentForProductData.kitList.map(function(kit, index){
        return <Row className="equipment-row">
                    <div className="equipment-info-header">{kit.counter > 1 ? `${kit.counter} ${kit.kitTitle}`: `${kit.kitTitle}`}</div>
                    {kit.counter > 1 ? <span className="span-txt">עבור כל אחד יש להחזיר: </span> : <span className="span-txt">עבורו יש להחזיר: </span>}
                    {getKits(kit)}
                </Row>
    })

    function displayAllItemsToReturn() {
        if(props.finalDisconnectResponse == "") {
            gaEvent(gaParams.DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_DISCONNECT_PAGE.category, gaParams.DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_DISCONNECT_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.finalDisconnectResponse && props.finalDisconnectResponse === true) {
            gaEvent(gaParams.DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.category, gaParams.DISCONNECT_CLICK_ON_VIEW_PRODUCTS_IN_SUCCESSFUL_DISCONNECT_SUMMARY_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        setIsShowOther(!isShowOther);
    }

    async function redirectTo() {

        gaEvent(gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POP_UP.category, gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POP_UP.eventType, props.serviceToDisconnect.serviceType)
        const today = getDates(1);

        const data = {
            ProductId: props.serviceToDisconnect.productId,
            Round: null,
            Lfdat: null,
            WaitTo: null,
            WaitFrom: null,
            PickLocation: null,
            DisconnectReasons: props.summarizeUserDisconnectDetails.disconnectReasons.join(", "),
            DisconnectReference: props.writtenProofNumber,
            DisconnectDate: today.options[0].date,
            HasDelivery: false,
            ShippingCost: null,
            Street: null,
            City: null,
            HouseNum: null,
            AptNum: null,
            PhoneNumber: props.UserInfo.contactNumber,
            Email: (props.summarizeUserDisconnectDetails.emailForm.email != "" ? props.summarizeUserDisconnectDetails.emailForm.email : null),
            NotesForDelivery: null
        }

        await props.disconnectProduct(data);
        setIsShow(false);

    }
    
    async function goBackHome() {
        props.clearStateHistoryAction();
        var content = await props.context.loadContentByPath(props.redirectTo);
        props.context.navigateTo(content);
    }


    function next() {
        props.emailInStore.email && props.emailInStore.email !== "" ? gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventType, Helper.objToString({serviceType: props.serviceToDisconnect.serviceType, filledEmail: true}, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventParams)) : gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventType, Helper.objToString({serviceType: props.serviceToDisconnect.serviceType, filledEmail: false}, gaParams.DISCONNECT_CLICK_CONTINUE_SUMMARIZE_DISCONNECT_PAGE.eventParams));
        if(props.emailInStore.email && props.emailInStore.email != "" && props.emailInStore.errors.email != "") {
            setActive(false);
            return;
        }
        setClicked(true);
        setIsShow(true);
    }

    function reportGAOnSelfCare() {
        gaEvent(gaParams.DISCONNECT_CLICK_ON_SELF_CARE_CENTER_DISCONNECT_SUMMARY_PAGE.category, gaParams.DISCONNECT_CLICK_ON_SELF_CARE_CENTER_DISCONNECT_SUMMARY_PAGE.eventType, props.serviceToDisconnect.serviceType)
    }

    return (
        <Container className="SummarizeSelfDisconnect-root"> 
            <Row className="header-row">
                {props.finalDisconnectResponse === false ? <h3 className="header">שלב הסיכומים ואישור הניתוק</h3> : <h3 className="header">סיכום פרטי הניתוק</h3>}
                {props.finalDisconnectResponse === true && clicked ? <h5 className="v-header">תודה שהיית איתנו</h5> : null}
                {props.finalDisconnectResponse === true && clicked ? <h6 className="v-header">הניתוק הושלם ותוך כמה דקות השירות יעלם גם מהאזור האישי ומהרשימה שלך</h6> : null}
            </Row>
            {props.finalDisconnectResponse === true && clicked || props.finalDisconnectResponse === true && props.deliverySet === false?
            <Row className="user-summary-number-row">
                <Col>
                    <div className="detail"><span className="txt">מספר אסמכתא: </span>{props.writtenProofNumber}</div>
                </Col>
            </Row> : null }
            {isBrowser ? 
            <Row className="user-details-row">
                <Col>
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
                <Col>
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col>
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
            </Row>
            :
            <>
            <Row className="user-details-row">
                <Col className="pl-1 pr-1">
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
                
            </Row>
            <Row className="user-details-row-second">
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
            </Row>
            </>
            }
            <Row className="service-disconnect-summary-row">
                <div className="service-disconnect-summary">
                    <h6 className="header">ניתוק מ: {props.serviceToDisconnect.title}</h6>
                    <div className="header-sub-txt">{props.serviceToDisconnect.email}</div>
                    <div className="header-sub-txt">מספר הלקוח: {props.serviceToDisconnect.customerId}</div>
                    <div className="header-sub-txt">בכתובת: {props.serviceToDisconnect.address}</div>
                    <div>
                        <h6 className="header">הניתוק ייכנס לתוקף בתאריך</h6>
                        <div className="header-sub-txt">{displayFullDay}</div>
                    </div>
                </div>
            </Row>
            {props.equipmentForProductData.kitList.length == 0 ? null : 
            <Row className="equipment-to-return-row"> 
                <div className="service-disconnect-summary">
                    <h6 className="header">רשימת הציוד להחזר</h6>
                    <div className="header-sub-txt">
                        תאריך אחרון להחזרה הינו ה- {props.equipmentForProductData.returnDay}
                        <br />
                        אי החזרה הציוד תהיה כרוכה בתשלום העלות שלו.
                    </div>
                    <div onClick={() => displayAllItemsToReturn()} className="linkTo">לצפייה ברשימה
                        <div className="arrow"/>
                    </div>
                    <PopUp showPopUp={isShowOther} onClose={closeItemsPopUp}>
                        <div className="kitPopUpContainer">
                            <h3 className="kit-header">רשימת הציוד להחזרה</h3>
                            <div className="kit-list-container">{kits}</div>
                        </div>
                    </PopUp>
                    <h6 className="header">אופן החזרת הציוד - החזרה עצמית</h6>
                    <a className="linkTo" onClick={() => reportGAOnSelfCare()} target="_blank" href={Config.cellcomServiceCenters}>לרשימת מרכזי השירות שלנו
                        <div className="arrow"/>
                    </a>
                </div>
            </Row>}
            {props.finalDisconnectResponse === true ? null :
            <Row className="mail-input-row">
                <span className="txt">ואפשר גם לקבל את הסיכום למייל:</span>
                <TextInput onChange={(e) => props.changeMailHandler({target: e.target, form: props.mailForm.emailForm})} id="mail-to" name="email" type="text" placeholder="כתובת מייל" /*required="required"*/ error={props.mailForm.emailForm.errors.email}/>
            </Row>
            }
            {props.finalDisconnectResponse === true && props.emailInStore.valid === true && props.emailInStore.email !== "" ? 
                <div className="mail-msg" style={{fontWeight: 'bold', marginTop: '10px'}}>נשלח את הפרטים למייל שהזנת</div> : null
            }
            <Row className="btn-row">
                {props.finalDisconnectResponse === true ? <BtnWhite text={'סיום'} onclick={() => goBackHome()}/> : <div className={`btn-container${active ? ' Active' : ''}`}><BtnSubmit text="אישור וסיום" onclick={() => next()}/></div>}
            </Row>
                <PopUp showPopUp={isShow} onClose={closePopUp}>
                    <PopUpContent redirectTo={redirectTo} closePopUp={closePopUp}/>
                </PopUp>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    summarizeUserDisconnectDetails: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    UserInfo: state.authentication.loginData.userDetails,
    equipmentForProductData: state.disconnectServicesBlock.equipmentForProductData,
    mailForm: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    loaderError: state.disconnectServicesBlock.loaderError,
    writtenProofNumber: state.disconnectServicesBlock.writtenProofNumber,
    emailInStore: state.disconnectServicesBlock.summarizeUserDisconnectDetails.emailForm,
    method: state.disconnectServicesBlock.summarizeUserDisconnectDetails.equipmentReturnMethod,
    deliverySet: state.disconnectServicesBlock.deliverySet
  });
  
  const mapDispatchToProps = {
    goToPage,
    setTimeDisconnectOccurred,
    changeMailHandler,
    validateMailHandler,
    disconnectProduct,
    showAppLoader,
    hideAppLoader,
    setDisconnectTypeOfService,
    setServiceToDisconnect,
    resetState,
    clearStateHistoryAction
  };

export default connect(mapStateToProps, mapDispatchToProps)(SummarizeSelfDisconnect);